import React, { useEffect, useState } from 'react'
// import NumberScroller from "../../components/NumberScroller"
import lodash from 'lodash'
import { Col, Row } from 'antd'
import useGlobalConfigStore from '@/stores/globalConfig'
import useStationStore from '@/stores/oneStation'
import { useParams } from 'react-router-dom'
import MqttServer from '@/utils/mqttUtil'
import { getDeviceData } from '@/utils/getData'
import { FunGroup } from '@/type/stationType'
import ItemValue from './components/ItemValue'

const BaseInfo: React.FC = () => {
  const { deviceId } = useParams()
  const mqtt_serve = useStationStore(state => state.mqtt_serve)
  const device = useStationStore(state => state.device)
  const initFinished = useGlobalConfigStore(state => state.initFinished)
  let targetGroup: FunGroup | undefined,
    mqtt: MqttServer | undefined,
    uuid: string = '',
    id: number = 0
  const [data, setData] = useState<{ label: string; value: string | number; unit: string }[]>([])

  const getData = async () => {
    if (targetGroup) {
      let res: any
      try {
        res = await getDeviceData(
          [{ device_id: Number(id), defines: targetGroup.funs.map(item => item.fun_code) }],
          mqtt as MqttServer,
          uuid
        )
        if (res.code === 1) {
          res.data[0].datas.forEach((item: { id: number; property_code: string; value: string }) => {
            let targetFun = targetGroup?.funs.find(fun => fun.fun_code === item.property_code)
            if (targetFun) {
              targetFun.value = Number(item.value)
            }
          })
          // console.log(targetGroup)
        }
      } catch (e) {
        console.log(e)
      }
      const funs = targetGroup.funs

      setData(
        funs.map(item => ({
          label: item.fun_name,
          value:
            item.type === 'value'
              ? item.value
              : item.type === 'option'
              ? item.type_detail.find(detail => detail.value == item.value)?.name || ''
              : '',
          unit: item.unit,
        }))
      )
    }
  }

  useEffect(() => {
    if (initFinished) {
      const targetDevice = lodash.cloneDeep(device.find(item => item.id === Number(deviceId)))
      if (targetDevice) {
        targetGroup = targetDevice.fun_group?.find(item => item.group_name === 'Basic')
        mqtt = mqtt_serve[targetDevice.mqtt_server_id]
        uuid = targetDevice.iot_gateway_uuid
        id = targetDevice.device_id
      }
      getData()
    }
  }, [initFinished])

  return (
    <div className='inverter-baseInfo'>
      <Row gutter={[40, 0]}>
        {data.map((item, index) => (
          <Col span={8} key={item.label}>
            <div className='item'>
              <ItemValue {...item} />
              {index % 3 === 0 && <div className='su'></div>}
            </div>
          </Col>
        ))}
      </Row>
    </div>
  )
}

export default BaseInfo

// import React, { useState } from "react"
// import { Col, Row, Segmented } from "antd"
// import Solar from "./Solar"
// import Battery from "./Battery"
// import Load from "./Load"
// import Gen from "./Gen"
// import Grid from "./Grid"
// import NumberScroller from "@/components/NumberScroller"

// const DeviceDetail: React.FC = () => {
//   return <Solar />
// }

// const BaseInfo: React.FC = () => {
//   const testData = [
//     { label: "Device_type:", value: "3phase hybrid", unit: "" },
//     { label: "Run_state:", value: "normal", unit: "" },
//     { label: "Protocol Version:", value: "256", unit: "" },
//     { label: "SN:", value: "20021541", unit: "" },
//   ]

//   return (
//     <div className="inverter-baseInfo">
//       <div className="items">
//         <Row gutter={[40, 0]}>
//           {testData.map((v, k) => (
//             <Col span={8} key={k}>
//               <div className="item">
//                 <div className="itemValue">
//                   <div className="itemValue-label">{v.label}</div>
//                   <div className="itemValue-value">
//                     <NumberScroller targetNumber={v.value} />
//                     <span>{v.unit}</span>
//                   </div>
//                 </div>
//                 {k % 3 === 0 && <div className="su"></div>}
//               </div>
//             </Col>
//           ))}
//         </Row>
//       </div>
//     </div>
//   )
// }

// const ComponentName: React.FC = () => {
//   const [selectedOption, setSelectedOption] = useState("PV&Solar")

//   const renderComponent = () => {
//     switch (selectedOption) {
//       case "Basic Information":
//         return <BaseInfo />
//       case "PV&Solar":
//         return <Solar />
//       case "Grid":
//         return <Grid />
//       case "Battery":
//         return <Battery />
//       case "Load":
//         return <Load />
//       case "Gen":
//         return <Gen />
//       default:
//         return <BaseInfo />
//     }
//   }

//   return (
//     <div id="inverter">
//       <div className="inverter-Segmented">
//         <Segmented
//           defaultValue="PV&Solar"
//           options={["PV&Solar", "Grid", "Battery", "Load", "Gen", "Basic Information"]}
//           onChange={(value) => setSelectedOption(value)}
//         />
//       </div>
//       <div className="inverterBody">{renderComponent()}</div>
//     </div>
//   )
// }

// export default ComponentName
